import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SELECT_PLACING_PERIOD = 'PUBLISH_TERMS :: SELECT_PLACING_PERIOD';

export type TSelectPlacingPeriodAction = IReduxAction<typeof SELECT_PLACING_PERIOD, string>;

export const selectPlacingPeriod = actionGenerator<typeof SELECT_PLACING_PERIOD, string>(SELECT_PLACING_PERIOD);
